import { Routes } from '@angular/router';
import { RenderInterfaceGuard } from 'viggo-sistemas-core-web';

export const routesSysadminLocalidades: Routes = [
  {
    path: 'mesorregioes',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      menuKey: 'LOCALIZACAO',
      breadcrumb: { label: 'Mesorregião', icon: 'pi pi-fw pi-map' },
      backend_path: '/mesorregioes',
      module: 'MESOREGIAO'
    },
    loadChildren: () =>
      import('@app/modules/parametrizacao/mesorregiao/mesorregiao.module').then(
        m => m.MesorregiaoModule
      )
  },
  {
    path: 'microrregioes',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      menuKey: 'LOCALIZACAO',
      breadcrumb: { label: 'Microrregião', icon: 'pi pi-fw pi-map' },
      backend_path: '/microrregioes',
      module: 'MICROREGIAO'
    },
    loadChildren: () =>
      import(
        '@app/modules/parametrizacao/microrregiao/microrregiao.module'
      ).then(m => m.MicrorregiaoModule)
  },
  {
    path: 'municipios',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      menuKey: 'LOCALIZACAO',
      breadcrumb: { label: 'Municipio', icon: 'pi pi-fw pi-map' },
      backend_path: '/municipios',
      module: 'MUNICIPIO'
    },
    loadChildren: () =>
      import('@app/modules/parametrizacao/municipio/municipio.module').then(
        m => m.MunicipioModule
      )
  },
  {
    path: 'regioes',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      menuKey: 'LOCALIZACAO',
      breadcrumb: { label: 'Região', icon: 'pi pi-fw pi-map' },
      backend_path: '/regioes',
      module: 'REGIAO'
    },
    loadChildren: () =>
      import('@app/modules/parametrizacao/regiao/regiao.module').then(
        m => m.RegiaoModule
      )
  },
  {
    path: 'paises',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      menuKey: 'LOCALIZACAO',
      breadcrumb: { label: 'Países', icon: 'pi pi-fw pi-map' },
      backend_path: '/paises',
      module: 'PAIS'
    },
    loadChildren: () =>
      import('@app/modules/parametrizacao/paises/pais.module').then(
        m => m.PaisModule
      )
  },
  {
    path: 'ufs',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      menuKey: 'LOCALIZACAO',
      breadcrumb: { label: 'UF', icon: 'pi pi-fw pi-map' },
      backend_path: '/ufs',
      module: 'UF'
    },
    loadChildren: () =>
      import('@app/modules/parametrizacao/uf/uf.module').then(m => m.UFModule)
  }
];
